export const Colors = {
  White: '#ffffff',
  LightGray: '#cccccc',
  Gray: '#323232',
  // Light Theme
  Green: '#50eba9',
  Red: '#E02020',
  Canary: '#FAEB3F',
  // Dark Theme
  Move: '#54f0f7',
  Exercise: '#c1ff00',
  Stand: '#ef135f'
};

export const THEMES = {
  dark: {
    LegendColorPercentage: Colors.White,
    LegendColor: Colors.LightGray,
    RingColors: [Colors.Stand, Colors.Exercise, Colors.Move]
  },
  light: {
    LegendColorPercentage: Colors.Gray,
    LegendColor: Colors.LightGray,
    RingColors: [Colors.Green, Colors.Canary, Colors.Red]
  }
};

export const shadeColor = (color, amount) => {
  if (color) return `#${color.replace(/^#/, '').replace(/../g, color => (`0${Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)}`).substr(-2))}`;
  return 'red';
};
